export const settings = () => ({
    display: 'grid',
    gridTemplateColumns: '1fr 1.54fr',
    gridColumnGap: '1.25rem',
    alignItems: 'flex-start',
});
